import { Directive } from '@angular/core';

import { FormValue, FormValueState } from '../form-controls/entities/form-value.entity';
import { BaseControlValueAccessor } from './base-control-value-accessor';

@Directive()
export abstract class SingleValueFormInput<T> extends BaseControlValueAccessor {
    writeValue(obj: any): void {
        if (obj === null) {
            this.unset();
            return;
        }

        if (obj instanceof FormValue) {
            switch (obj.state) {
                case FormValueState.SET:
                    this.set(obj.value);
                    break;
                case FormValueState.INDETERMINATE:
                    this.makeIndeterminate();
                    break;
                case FormValueState.UNSET:
                    this.unset();
                    break;
                default:
                    this.unset();
            }
        } else {
            console.error('ShFormTextComplexBaseComponent:: value must be of type FormValue', obj);
            this.unset();
            return;
        }
    }

    propagateChange(_: FormValue<T>): void {
        super.propagateChange(_);
    }

    propagateSimpleChange(_: T): void {
        super.propagateChange(_);
    }

    protected abstract set(obj: T): void;

    protected abstract unset(): void;

    protected abstract makeIndeterminate(): void;
}
